import React from 'react';
import { Svg } from 'src/components/Svg/Svg';
import classnames from 'classnames';
import { usePhoneNumber } from 'src/util/getPhoneNumber';

import classes from './FooterAction.scss';

type Props = {
    className?: string;
};

export const FooterAction: React.FC<Props> = ({ className }) => {
    const phoneNumber = usePhoneNumber('spaced');
    return (
        <p className={classnames(classes.footerAction, className)}>
            <Svg name="phone" />
            Call us free on <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
        </p>
    );
};
